class HHPodcastCarousel extends HTMLElement {
  constructor() {
    super()

    this.sectionId = this.getAttribute('data-section-id')

    this.mobileSeriesSelect = this.querySelector(
      `#${this.sectionId}-series-filter-mobile`
    )
    this.mobileSecondaryFilterSelect = this.querySelector(
      `#${this.sectionId}-secondary-filter-mobile`
    )
    this.seriesRadioInputs = this.querySelectorAll('[data-series-filter]')
    this.secondaryFiltersContainer = this.querySelector(
      '[data-secondary-filters]'
    )
    this.secondaryFilterRadioInputs = this.querySelectorAll(
      '[data-secondary-filter]'
    )
    this.defaultSecondaryFilterRadioInput = this.querySelector(
      '[data-secondary-filter][value=""]'
    )
    this.slides = this.querySelectorAll('[data-podcast-carousel-slide]')

    this.handleSeriesFilterChange = this.handleSeriesFilterChange.bind(this)
    this.handleSecondaryFilterChange =
      this.handleSecondaryFilterChange.bind(this)

    this.seriesFilter = this.querySelector('[data-series-filter]:checked')?.value ?? ''
    this.secondaryFilter = ''
  }

  connectedCallback() {
    this.init()

    this.mobileSeriesSelect?.addEventListener(
      'change',
      this.handleSeriesFilterChange
    )
    this.mobileSecondaryFilterSelect?.addEventListener(
      'change',
      this.handleSecondaryFilterChange
    )

    this.seriesRadioInputs.forEach((input) => {
      input.addEventListener('change', this.handleSeriesFilterChange)
    })
    this.secondaryFilterRadioInputs.forEach((input) => {
      input.addEventListener('change', this.handleSecondaryFilterChange)
    })
  }

  disconnectedCallback() {
    this.mobileSeriesSelect?.removeEventListener(
      'change',
      this.handleSeriesFilterChange
    )
    this.mobileSecondaryFilterSelect?.removeEventListener(
      'change',
      this.handleSecondaryFilterChange
    )

    this.seriesRadioInputs.forEach((input) => {
      input.removeEventListener('change', this.handleSeriesFilterChange)
    })
    this.secondaryFilterRadioInputs.forEach((input) => {
      input.removeEventListener('change', this.handleSecondaryFilterChange)
    })
  }

  handleSeriesFilterChange(event) {
    this.seriesFilter = event.target.value

    this.secondaryFilter = ''
    if (this.defaultSecondaryFilterRadioInput) {
      this.defaultSecondaryFilterRadioInput.checked = true
    }
    if (this.mobileSecondaryFilterSelect) {
      this.mobileSecondaryFilterSelect.value = ''
    }

    this.filterSlides(true)
  }

  handleSecondaryFilterChange(event) {
    this.secondaryFilter = event.target.value

    this.filterSlides()
  }

  filterSlides(reRenderSecondaryFilters) {
    const requiredSecondaryFilters = new Set()

    this.slides.forEach((slide) => {
      const series = slide.getAttribute('data-series')
      const secondaryFilterValue = slide.getAttribute(
        'data-secondary-filter-value'
      )

      if (
        series === this.seriesFilter &&
        (!this.secondaryFilter || secondaryFilterValue === this.secondaryFilter)
      ) {
        slide.classList.remove('hidden')

        if (secondaryFilterValue) {
          requiredSecondaryFilters.add(secondaryFilterValue)
        }
      } else {
        slide.classList.add('hidden')
      }
    })

    if (reRenderSecondaryFilters && this.secondaryFiltersContainer) {
      this.updateSecondaryFilters(requiredSecondaryFilters)
    }

    this.swiperCarousel.update()
  }

  updateSecondaryFilters(filtersSet) {
    if (filtersSet.size > 1) {
      this.secondaryFiltersContainer.classList.remove('hidden')

      this.secondaryFilterRadioInputs.forEach((input) => {
        if (filtersSet.has(input.value) || input.value === '') {
          input.parentElement.classList.remove('hidden')

          this.mobileSecondaryFilterSelect
            ?.querySelector(`option[value='${input.value}']`)
            ?.classList.remove('hidden')
        } else {
          input.parentElement.classList.add('hidden')

          this.mobileSecondaryFilterSelect
            ?.querySelector(`option[value='${input.value}']`)
            ?.classList.add('hidden')
        }
      })

      if (this.mobileSecondaryFilterSelect) {
        this.mobileSecondaryFilterSelect.disabled = false
      }
    } else {
      this.secondaryFiltersContainer.classList.add('hidden')
      if (this.mobileSecondaryFilterSelect) {
        this.mobileSecondaryFilterSelect.disabled = true
      }
    }
  }

  init() {
    this.swiperCarousel = new Swiper(
      this.querySelector('[data-podcast-carousel]'),
      {
        slidesPerView: 1.5,
        spaceBetween: 5,
        navigation: {
          nextEl: this.querySelector('.js-swiper-button-next'),
          prevEl: this.querySelector('.js-swiper-button-prev'),
        },
        breakpoints: {
          750: {
            slidesPerView: 2.5,
          },
          990: {
            slidesPerView: 4.5,
          },
        },
      }
    )
  }
}

customElements.define('hh-podcast-carousel', HHPodcastCarousel)
